import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ClientOnlineSettingsComponent } from './client-online-settings/client-online-settings.component';

@Component({
  selector: 'app-client-online',
  templateUrl: './client-online.component.html'
})
export class ClientOnlineComponent implements OnInit {
  @Output('UpdateOrganisationSettings') updateOrganisationSettings: EventEmitter<any> = new EventEmitter<any>();
  @Output('UpdateOrganisationPlugins') updateOrganisationPlugins: EventEmitter<any> = new EventEmitter<any>();
  @Input('OrganisationSettings') set organisationSettings(organisationSettings: any){
    this.useClientOnline = (organisationSettings.UseClientOnline == undefined || organisationSettings.UseClientOnline == "" || organisationSettings.UseClientOnline == "false") ? false : true;
    this.pinkwebPassword = (organisationSettings.PinkwebPassword == undefined || organisationSettings.PinkwebPassword == "" || organisationSettings.PinkwebPassword == "false") ? "" : organisationSettings.PinkwebPassword;
    this.pinkwebUrl = (organisationSettings.PinkwebUrl == undefined || organisationSettings.PinkwebUrl == "" || organisationSettings.PinkwebUrl == "false") ? "" : organisationSettings.PinkwebUrl;
    this.pinkwebUsername = (organisationSettings.PinkwebUsername == undefined || organisationSettings.PinkwebUsername == "" || organisationSettings.PinkwebUsername == "false") ? "" : organisationSettings.PinkwebUsername;
  }
  @Input('Plugins') set plugins(plugins: any){
    this.pinkwebAccordering = plugins.PinkwebAccordering;
    this.pinkwebDossier = plugins.PinkwebDossier;

    if (plugins.PinkwebAccordering.enabled || plugins.PinkwebDossier.enabled) {
      this.useClientOnline = true;
    }
  }
  useClientOnline: boolean = false;
  pinkwebPassword: string = "";
  pinkwebUrl: string = "";
  pinkwebUsername: string = "";
  pinkwebAccordering: any;
  pinkwebDossier: any;
  form!: UntypedFormGroup;

  constructor(private modalService: NgbModal) {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  toggleShowSettings(event: any){
    let key =(event.target as HTMLInputElement).id;
    let checked = (event.target as HTMLInputElement).checked;
    let updatedSettings: any[] = [{key:key, value:checked}];
    let updatedPlugins: any[] = [];
    if(key === "UseClientOnline" && checked === false){
      updatedSettings.push({key:'PinkwebUrl', value:"" });
      updatedSettings.push({key:'PinkwebUsername', value:"" });
      updatedSettings.push({key:'PinkwebPassword', value:false });
      updatedPlugins.push({PluginCode:'PinkwebDossier', Enabled:false });
      updatedPlugins.push({PluginCode:'PinkwebAccordering', Enabled:false });
    }
    this.updateOrganisationSettings.emit(updatedSettings);
    if(updatedPlugins.length > 0 ) this.updateOrganisationPlugins.emit(updatedPlugins);
  }

  toggleShowPlugins(event: any){
    let key =(event.target as HTMLInputElement).id;
    let checked = (event.target as HTMLInputElement).checked;
    this.updateOrganisationPlugins.emit([{PluginCode:key, Enabled:checked }]);
  }

  dialogClientOnline(clientOnlineName: string) {
    let ngbModalOptions: NgbModalOptions = {
      keyboard : false,
      centered: true,
      size: 'md',
      windowClass: 'dialog-bg-white'
    };
    const modalRef = this.modalService.open(ClientOnlineSettingsComponent, ngbModalOptions);
    modalRef.componentInstance.clientOnlineName = clientOnlineName;
    modalRef.componentInstance.useClientOnline = this.useClientOnline;
    modalRef.componentInstance.pinkwebPassword = this.pinkwebPassword;
    modalRef.componentInstance.pinkwebUrl = this.pinkwebUrl;
    modalRef.componentInstance.pinkwebUsername = this.pinkwebUsername;
    modalRef.componentInstance.updateOrganisationSettings.subscribe(async (item:any) => {
      this.updateOrganisationSettings.emit(item);
      modalRef.close();
    });
  }

}
